export function mapClickUpFields(tasks, fieldMap) {
  return tasks.map(task => {
    const mapped = {};

    Object.entries(fieldMap).forEach(([fieldName, fieldKey]) => {
      let value = null;

      // Step 1: Try custom fields
      const cf = task.custom_fields?.find(f => f.id === fieldKey);
      if (cf) {
        if (cf.type === "drop_down") {
          const selected = cf.type_config?.options?.find(opt => opt.orderindex === cf.value);
          value = selected?.name ?? null;
        } 
        else if (cf.type === 'date') {
          value = new Date(Number(cf.value)).toISOString().split("T")[0];
        }
        else {
          value = cf.value;
        }
      }

      // Step 2: Try nested props (e.g., "status.status")
      if (value === null) {
        value = getNestedValue(task, fieldKey);
      }

      // Step 3: Try direct props
      if (value === null && task[fieldKey] !== undefined) {
        value = task[fieldKey];
      }

      mapped[fieldName] = value ?? null;
    });

    return {
      ...mapped
    };
  });
}

function getNestedValue(obj, path) {
  return path.split('.').reduce((o, key) => o?.[key], obj);
}